export const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const regexPassword = /^\S{8,}$/;
export const regexNoEmptyString = /^(?!\s*$).+/;
export const regexTrIban = /^TR\d{24}$/;
